import { NgClass, TitleCasePipe } from "@angular/common";
import { Component, InputSignal, input, inject, computed, WritableSignal, signal, output } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { PlanTemplateDto } from "../../../../../../api/models/fraud.models";
import { getPriceRange, groupCostProviders } from "../../../../../utils/pricing.utils";

type BillingType = 'monthly' | 'annual';

@Component({
  selector: 'app-purchase-flow-stage-choose-billing',
  imports: [NgClass, MatIcon, TitleCasePipe],
  templateUrl: './purchase-flow-stage-choose-billing.component.html',
  host: {
    class: 'block'
  }
})
export class PurchaseFlowStageChooseBillingComponent {
  public readonly choosePackage: InputSignal<PlanTemplateDto> = input.required<PlanTemplateDto>();

  readonly matDialogRef = inject(MatDialogRef);

  public readonly priceRange = computed<{ from: string; to: string }>(() => {
    const pkg = this.choosePackage();
    return {
      from: getPriceRange(groupCostProviders(pkg), 'min'),
      to: getPriceRange(groupCostProviders(pkg), 'max'),
    };
  });

  public readonly selectedBilling: WritableSignal<BillingType> = signal<BillingType>('annual');

  public readonly amount = computed(() => {
    const pkg = this.choosePackage();
    const selected = this.selectedBilling();
    const value = selected === 'annual' ? pkg.planPriceYearly : pkg.planPriceMonthly;
    if (!Number.isFinite(value) || value <= 0) return '0.00';
    return `${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  });

  public readonly continueToInvoice = output<BillingType>();

  public onContinue(): void {
    this.continueToInvoice.emit(this.selectedBilling());
  }
}
